// Per-type filter operator sets for the column menu.
//
// Text was the only set until now, so numeric and date columns were offered
// string operators ("contains 2026-08" on a formatted date is close to useless)
// or opted out of the menu entirely with disableColumnMenu. Operators and
// wording follow the ACES New Experience grid so the two products match.
//
// The stored filter value shape is unchanged: { operator, values: string[] }.
// Values stay strings — comparison coerces at filter time (columnFilterFn) — so
// nothing downstream needs to know about types.

// Operators carrying no value; applied immediately without opening the modal.
export const IMMEDIATE_OPERATORS = ["empty", "nempty"];

// Operators whose single input is parsed as a comma-separated list.
export const LIST_OPERATORS = ["in", "nin"];

// Operators needing two values (from/to). Inclusive at both ends.
export const RANGE_OPERATORS = ["between"];

export const TEXT_OPERATORS = [
  "eq",
  "neq",
  "contains",
  "ncontains",
  "empty",
  "nempty",
  "in",
  "nin",
];

export const NUMERIC_OPERATORS = [
  "eq",
  "neq",
  "gt",
  "gte",
  "lt",
  "lte",
  "between",
  "empty",
  "nempty",
];

export const DATE_OPERATORS = [
  "eq",
  "before",
  "onOrBefore",
  "after",
  "onOrAfter",
  "between",
  "empty",
  "nempty",
];

// Labels for the operators introduced here. Text operator labels stay in
// ColumnMenu's OPERATOR_LABELS, which this is merged into.
export const TYPED_OPERATOR_LABELS = {
  gt: "Greater Than",
  gte: "Greater Than or Equal To",
  lt: "Less Than",
  lte: "Less Than or Equal To",
  before: "Before",
  onOrBefore: "On or Before",
  after: "After",
  onOrAfter: "On or After",
  between: "Between (Inclusive)",
};

/** Operator list for a resolved column type (see columnTypeOf). */
export function operatorsForType(type) {
  if (type === "numeric") return NUMERIC_OPERATORS;
  if (type === "date") return DATE_OPERATORS;
  return TEXT_OPERATORS;
}

/**
 * Input type for the value modal. `date` and `number` give native pickers and
 * keypads — deliberately not @mui/x-date-pickers, which is a dependency but is
 * used nowhere in the app, so adopting it would mean provider setup plus
 * restyling to match a non-MUI UI for no functional gain.
 */
export function inputTypeForType(type) {
  if (type === "numeric") return "number";
  if (type === "date") return "date";
  return "text";
}
